var map;
var markers = [];
const startZoom = 8;
const startLat = 41.902782;
const startLon = 12.496365;

window.addEventListener("load", (event) => {
    initMap();

    initMarkers();
});

window.addEventListener('refreshMarkers', event => {
    initMarkers();
});

window.addEventListener('refreshFindLaundry', event => {
    findLaundry();
});

function initMap() {

    // Creazione mappa
    map = L.map('map', {scrollWheelZoom: false}).setView([startLat, startLon], startZoom);

    // Tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a> contributors | <a href="javascript:resetMap();">Reset map</a>'
    }).addTo(map);

    // Behaviour per attivare lo scroll solo dopo aver cliccato sulla mappa.
    //map.on('click', () => {
    //    map.scrollWheelZoom.enable();
    //});
    //map.on('mouseout', () => {
    //    map.scrollWheelZoom.disable();
    //});

    // Aggiunge il controllo per la localizzazione sulla mappa.
    L.control.locate().addTo(map);
}

function initMarkers() {
    const laundries = document.getElementsByClassName('laundry');

    cleanMarkers();

    // Vengono aggiunte le laundry alla mappa.
    for (let i = 0; i < laundries.length; i++) {
        let laundry = laundries[i];

        let iLat = laundry.getAttribute('data-lat');
        let iLon = laundry.getAttribute('data-lon');

        if (iLat && iLon) {
            let name = laundry.getAttribute('data-name');
            let address = laundry.getAttribute('data-add');
            let city = laundry.getAttribute('data-city');
            let id = laundry.getAttribute('data-id');

            marker = L.marker([iLat, iLon]).addTo(map).bindPopup("<b>" + name + "</b>" + "<br>" + address + ", " + city + "<br>" + "<span class='btn btn-link' onclick=\"Livewire.emit('openAvailabilityModal','" + id + "');\">Controlla disponibilità</span>");
            markers.push(marker);

            // Aggiungo l'evento on click
            laundry.onclick = function () {
                map.flyTo([iLat, iLon], 14);
            };
        }
    }

}
window.initMarkers = initMarkers;

function cleanMarkers() {
    markers.forEach(function (marker) {
        marker.removeFrom(map);
    });
}
window.cleanMarkers = cleanMarkers;

function findLaundry() {
    const searchInput = document.getElementById('laundryfinder');
    const hidden = 'd-none';
    const result = document.getElementById('result');
    const laundries = document.getElementsByClassName('laundry');

    let filter = searchInput.value.toUpperCase();
    let count = 0;

    for (let i = 0; i < laundries.length; i++) {
        let laundry = laundries[i];
        let city = laundry.getAttribute('data-city').toUpperCase();
        let name = laundry.getAttribute('data-name');
        let address = laundry.getAttribute('data-add');

        if (name.toUpperCase().indexOf(filter) > -1) {
            laundry.classList.remove(hidden);
            count = count + 1;
        } else if (city.toUpperCase().indexOf(filter) > -1) {
            laundry.classList.remove(hidden);
            count = count + 1;
        } else if (address.toUpperCase().indexOf(filter) > -1) {
            laundry.classList.remove(hidden);
            count = count + 1;
        } else {
            laundry.classList.add(hidden);
        }
    }
    result.innerHTML = count + ' OneLaundry - <a href="javascript:clearSearch();">Reset</a>';
}
window.findLaundry = findLaundry;

// reset map
function resetMap() {
    map.closePopup();
    map.setView([startLat, startLon], startZoom);
}
window.resetMap = resetMap;

// clear search
function clearSearch() {
    document.getElementById('laundryfinder').value = '';
    findLaundry();
    resetMap();
}
window.clearSearch = clearSearch;

function onLocationFound(e) {
    var radius = e.accuracy;

    L.marker(e.latlng).addTo(map).bindPopup("You are within " + radius + " meters from this point").openPopup();
    L.circle(e.latlng, radius).addTo(map);
}
//map.on('locationfound', onLocationFound);

